module.exports = __webpack_public_path__ + "img/shimla-grey-icon.0edabe0.webp";